import React from 'react';
import "./title.css";

const Title = (props) => {
    return ( 
        <>
        <div className={props.stylebox}>
            <h1 className={props.classname}>
                {props.text}
            </h1>

            <p className={props.pclass}>
                {props.para}
                </p>

        </div>
        
        </>
     );
}
 
export default Title;